import { render, staticRenderFns } from "./DetailSubconPayment.vue?vue&type=template&id=f20c5192"
import script from "./DetailSubconPayment.vue?vue&type=script&lang=js"
export * from "./DetailSubconPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports